export * from './modal-new-account/modal-new-account.component';
